<template>
  <div class="scroll-hidden monitoring-table-wrapper shadow-monitoring">
    <global-loading v-if="$store.state.vaStore.expire_soon_k3l_kplh_loading" />
    <div class="pointer" style="position:absolute;right:2%;top:2%;font-size:20px">
      <i class="fa-solid fa-file-arrow-down" style="color:red" @click="downloadReport()"></i>
    </div>
    <div class="text-sm text-bold">
      Detail Expired Soon KPLH & K3L
    </div>
    <div class="mt10">
      <div class="brl-top-table-header border-bottom">
        <div class="brl-top-table-material">
          Vendor Name
          <span class="pointer" @click="vendorSortFunction()">
            <i class="fas fa-arrow-down" v-show="vendorSort"></i><i class="fas fa-arrow-up" v-show="!vendorSort"></i>
          </span>
        </div>
        <div class="brl-top-table-vendor">
          K3L/KPLH
          <span class="pointer" @click="k3lKplhSortFunction()">
            <i class="fas fa-arrow-down" v-show="k3lKplhSort"></i><i class="fas fa-arrow-up" v-show="!k3lKplhSort"></i>
          </span>
        </div>
        <div class="brl-top-table-vendor">
          Expired Date
          <span class="pointer" @click="expiredSortFunction()">
            <i class="fas fa-arrow-down" v-show="expiredSort"></i><i class="fas fa-arrow-up" v-show="!expiredSort"></i>
          </span>
        </div>
      </div>
      <div>
        <div class="brl-top-table-header" v-for="(item, index) in expireSoonK3lKplh" :key="index">
          <div class="brl-top-table-material col-elipsis">
            {{ item.nama_vendor }}
          </div>
          <div class="brl-top-table-vendor">{{ item.sumber_tabel }}</div>
          <div class="brl-top-table-vendor text-orange-bold">
            +{{ item.selisih_hari }}
          </div>
          <!-- <div class="brl-top-table-value">
            <div class="brl-display-value">
              {{ curencyDelimiter(item.total_value_usd) }}
            </div>
            <div
              class="brl-bar-chart"
              :style="
                `width: calc(100% - ${maxValueMaterial(item.total_value_usd)}%)`
              "
            ></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'
export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      listVendor: [
        {
          vendor: 'Az-Zahra',
          tipe: 'K3L',
          expiredDate: 10,
        },
        {
          vendor: 'Az-Zahra',
          tipe: 'KPLH',
          expiredDate: 9,
        },
        {
          vendor: 'Az-Zahra',
          tipe: 'K3L',
          expiredDate: 60,
        },
        {
          vendor: 'Az-Zahra',
          tipe: 'K3L',
          expiredDate: 60,
        },
        {
          vendor: 'Az-Zahra',
          tipe: 'KPLH',
          expiredDate: 60,
        },
        {
          vendor: 'Az-Zahra',
          tipe: 'K3L',
          expiredDate: 50,
        },
        {
          vendor: 'Az-Zahra',
          tipe: 'KPLH',
          expiredDate: 40,
        },
        {
          vendor: 'Az-Zahra',
          tipe: 'K3L',
          expiredDate: 30,
        },
      ],
      vendorSort: false,
      k3lKplhSort: false,
      expiredSort: false,
    }
  },

  computed: {
    expireSoonK3lKplh() {
      const data = this.$store.state.monitoringStore.expire_soon_k3l_kplh

      return data
    },
  },

  methods: {
    vendorSortFunction() {
      this.vendorSort = !this.vendorSort

      if (this.vendorSort) {
        this.expireSoonK3lKplh.sort((a, b) =>
          a.nama_vendor.localeCompare(b.nama_vendor)
        )
      } else {
        this.expireSoonK3lKplh.sort((a, b) =>
          b.nama_vendor.localeCompare(a.nama_vendor)
        )
      }
    },
    k3lKplhSortFunction() {
      this.k3lKplhSort = !this.k3lKplhSort

      this.expireSoonK3lKplh.sort((a, b) => {
        if (this.k3lKplhSort) {
          return a.sumber_tabel.localeCompare(b.sumber_tabel)
        } else {
          return b.sumber_tabel.localeCompare(a.sumber_tabel)
        }
      })
    },
    expiredSortFunction() {
      this.expiredSort = !this.expiredSort

      this.expireSoonK3lKplh.sort((a, b) => {
        if (this.expiredSort) {
          return a.selisih_hari - b.selisih_hari
        } else {
          return b.selisih_hari - a.selisih_hari
        }
      })
    },
    downloadReport() {
      const exportTitle = 'Expired Soon KPLH & K3L'
      let newData = this.expireSoonK3lKplh.map((item, index) => {
        let newDataItem = {
          no: index + 1,
          vendor: item.nama_vendor,
          tipe: item.sumber_tabel,
          expiredDate: item.selisih_hari,
        }

        return newDataItem
      })

      newData.unshift({})

      let start = this.$store.state.kpiStore.start
      let end = this.$store.state.kpiStore.end

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(newData)
        const title = [
          ['', '', '', '', '', '', '', '', ''],
          ['No', 'Vendor', 'Tipe', 'Expired Date'],
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
  },
}
</script>
<style scoped>
.region-container {
  width: 30%;
  font-size: 14px;
  font-weight: bold;
  border-top: 0.5px solid rgba(128, 128, 128, 0.3);
  border-right: 0.5px solid rgba(128, 128, 128, 0.3);
  text-align: right;
  padding-right: 5px;
}

.custom-bar-container {
  width: 70%;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.custom-bar-box {
  display: flex;
  height: 15px;
}

.custom-bar-color {
  border: 0.3px solid rgba(255, 192, 203);
  background: rgb(204, 0, 0);
  background: linear-gradient(90deg,
      rgba(204, 0, 0, 0.5) 0%,
      rgba(204, 0, 0, 0.3) 50%,
      rgba(255, 255, 255, 0.5) 100%);
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.region-value {
  font-size: 12px;
}

.text-orange-bold {
  color: #ff914c;
  font-weight: 700;
}
</style>
